import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import KnowledgePage from "./knowledge/KnowledgePage";
import { User } from "../models/API";

interface KnowledgeComponentProps {
  isOpen: boolean;
  menuWidth: number;
  currentTeamId: number;
  currentUserName: string;
  userConfig: User | null;
  effectiveRole: string;
}

// @ts-ignore
export const KnowledgeComponent: React.FC<KnowledgeComponentProps> = ({
  isOpen,
  menuWidth,
  currentTeamId,
  currentUserName,
  userConfig,
  effectiveRole,
}) => {
  const theme = useTheme();

  if (!isOpen) {
    return null;
  }

  // @ts-ignore
  return (
    isOpen && (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          ml: `${menuWidth}px`,
          transition: theme.transitions.create("margin-left", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
        }}
      >
        <KnowledgePage
          currentUserId={userConfig?.id!}
          currentUserName={currentUserName}
          userConfig={userConfig!}
          effectiveRole={effectiveRole}
        />
      </Box>
    )
  );
};

export default KnowledgeComponent;
